export const FIREBASE_CONFIG = {
	DEV: {
		apiKey: "AIzaSyCs2q1ZJnDZ4MWi4ERyPN2NmeegcwyPCjw",
		authDomain: "cana-dev-bf4bc.firebaseapp.com",
		projectId: "cana-dev-bf4bc",
		storageBucket: "cana-dev-bf4bc.firebasestorage.app",
		messagingSenderId: "421513141967",
		appId: "1:421513141967:web:1e7308b7f0bbdea2efa1ba",
		measurementId: "G-052C3D6JFV",
	},
	PROD: {
		apiKey: "AIzaSyBL472if_dHCSGe-JnzMmNLo0UkDtXq3og",
		authDomain: "cana-prod.firebaseapp.com",
		projectId: "cana-prod",
		storageBucket: "cana-prod.firebasestorage.app",
		messagingSenderId: "1025001736764",
		appId: "1:1025001736764:web:b6ffbb645a14ea0e775139",
		measurementId: "G-5J0SGZ979C",
	},
};
